import {keyMirror} from 'utils/DBUtils';

export const Types = keyMirror({
  REQUEST_PRIZES: null,
  REQUESTED_PRIZES: null,
  RECEIVED_PRIZES: null,
  SET_PRIZE_DATE_RANGE_FILTER_TYPE: null
});

export const requestPrizesAction = prizeType => ({
  type: Types.REQUEST_PRIZES,
  prizeType
});

export const requestedPrizesAction = prizeType => ({
  type: Types.REQUESTED_PRIZES,
  prizeType
});

export const receivedPrizesAction = () => ({
  type: Types.RECEIVED_PRIZES
});

export const setDateRangeFilterTypeAction = filterType => ({
  type: Types.SET_PRIZE_DATE_RANGE_FILTER_TYPE,
  filterType
});



// WEBPACK FOOTER //
// ./public/pages/ListPrizes/actions.js